import Color from "../color/Color";
import GridTile from "../grid/GridTile";
import LightSource from "./LightSource";
import LightSourceCache from "./LightSourceCache";

export default class LightSourceCreator {
    /**
     * @param {Color} color 
     * @param {number} radius 
     * @param {LightSourceCache} lightSourceCache 
     */
    constructor(color, radius, lightSourceCache) {
        /**
         * @constant
         * @type {Color}
         */
        this.color = color;
        /**
         * @constant
         * @type {number}
         */
        this.radius = radius;
        /**
         * @constant
         * @type {LightSourceCache}
         */
        this.lightSourceCache = lightSourceCache;
    }

    /**
     * @param {GridTile} tile
     * @returns {LightSource}
     */
    createLightSource(tile) {
        /**
         * @type {LightSource}
         */
        const lightSource = this.lightSourceCache.get();
        lightSource.set(tile, this.color, this.radius);
        return lightSource;
    }

}